import React from 'react';

import ReportingContext, { createStore } from 'src/scenes/BusinessIntelligence/containers/Reporting/Context.tsx';

export const ReportingFiltersContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const store = React.useMemo(() => createStore(), []);
  return <ReportingContext.Provider value={store}>{children}</ReportingContext.Provider>;
};
